window.Features = function () {
    let featureSldr = $('.FeatureContent');
    $('.FeaturesInt').simpleTab({
        container: '.VehicleSldr-options',
        handler: '.VehicleSldr-options>a',
        content: '.FeatureContent',
        attribute: 'rel',
        namespeace: 'fint',
        effect: "class",
        caller: function () {
            $('.FeaturesInt .VehicleSldr-img').filter('.slick-initialized').slick('setPosition');
            $('.FeaturesInt .VehicleSldr_txt').filter('.slick-initialized').slick('setPosition');
        }
    });


    $('.FeaturesExt').simpleTab({
        container: '.VehicleSldr-options',
        handler: '.VehicleSldr-options>a',
        content: '.FeatureContent',
        attribute: 'rel',
        namespeace: 'fext',
        effect: "class",
        caller: function () {
            $('.FeaturesExt .VehicleSldr-img').filter('.slick-initialized').slick('setPosition');
            $('.FeaturesExt .VehicleSldr_txt').filter('.slick-initialized').slick('setPosition');
        }
    });

    $('.FeaturesTech').simpleTab({
        container: '.VehicleSldr-options',
        handler: '.VehicleSldr-options>a',
        content: '.FeatureContent',
        attribute: 'rel',
        namespeace: 'ftech',
        effect: "class",
        caller: function () {
            $('.FeaturesTech .VehicleSldr-img').filter('.slick-initialized').slick('setPosition');
            $('.FeaturesTech .VehicleSldr_txt').filter('.slick-initialized').slick('setPosition');
        }
    });

    $('.FeaturesHyb').simpleTab({
        container: '.VehicleSldr-options',
        handler: '.VehicleSldr-options>a',
        content: '.FeatureContent',
        attribute: 'rel',
        namespeace: 'fhyb',
        effect: "class",
        caller: function () {
            $('.FeaturesHyb .VehicleSldr-img').filter('.slick-initialized').slick('setPosition');
            $('.FeaturesHyb .VehicleSldr_txt').filter('.slick-initialized').slick('setPosition');
        }
    });

    featureSldr.each(function (i) {

        $(this).find('.VehicleSldr-img').attr('id', 'SldrImg' + this.id);
        $(this).find('.VehicleSldr_txt').attr('id', 'vSldrTxt' + this.id);

    })


    let vSlidrImg = $('.VehicleSldr-img');
    let vSlidrtxt = $('.VehicleSldr_txt');

    vSlidrImg.each((index, elem) => {
        $(elem).slick({
            arrows: false,
            dots: false,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: 'ondemand',
            lazyLoaded: function (event, image) {
                console.log(image);
            },
            asNavFor: vSlidrtxt[index]
        });
    });
    vSlidrtxt.each((index, elem) => {
        let $elm = $(elem);
        $elm.slick({
            dots: true,
            arrows: true,
            infinite: false,
            appendDots: $elm.prev().find('.slide-m-dots'),
            prevArrow: $elm.prev().find(".slide-m-prev"),
            nextArrow: $elm.prev().find(".slide-m-next"),
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: vSlidrImg[index]
        });
    });


};
